import { Actions } from '@/utils/dictionaries/actionsDictionary/actions'

export const pagesDictionary = {
  '/_error': { title: 'Oops, há um problema nessa página' },
  '/home': { title: 'Início' },
  '/members': { title: 'Consultar participantes', action: Actions.LIST_USERS },
  '/members/[member]': { title: 'Detalhes do consumidor', action: Actions.LIST_USERS },
  '/members/new': { title: 'Novo participante', action: Actions.CREATE_USER },
  '/events': { title: 'Eventos', action: Actions.LIST_EXCLUSIVE_EVENTS },
  '/events/[eventId]': { title: 'Editar evento', action: Actions.EDIT_EXCLUSIVE_EVENT },
  '/benefits/events': { title: 'Eventos', action: Actions.LIST_BENEFITS_EVENTS },
  '/benefits/event': { title: 'Detalhes do evento', action: Actions.CREATE_EXCLUSIVE_EVENT },
  '/benefits/event/new': { title: 'Cadastrar evento', action: Actions.CREATE_EXCLUSIVE_EVENT },
  '/acceleration': {
    title: 'Acelerador de pontos',
    action: Actions.LIST_ACCELERATIONS
  },
  '/acceleration/new': {
    title: 'Cadastrar novo acelerador',
    action: Actions.CREATE_ACCELERATION
  },
  '/acceleration/[campaignId]/edit': {
    title: 'Editar acelerador',
    action: Actions.EDIT_ACCELERATION
  },
  '/acceleration/[campaignId]': {
    title: 'Detalhes do acelerador',
    action: Actions.LIST_ACCELERATION
  },
  '/oauth': { title: 'Estamos verificando sua autorização' }
}
